import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { SubscriptionApiService } from 'features/subscription-management/api/subscription-api.service';
import { queryClient } from 'providers';

import { subscriptionQueryKeys } from './query-keys';
const { deleteSubscription } = SubscriptionApiService();

export const useDeleteSubscription = () => {
  const { message } = App.useApp();

  return useMutation(
    (id: string) => {
      return deleteSubscription(id); // Pass the subscription id to the delete function
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage); // Display error message
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: subscriptionQueryKeys.all, // Invalidate subscription queries to refresh the data
        });
        message.success('Subscription deleted successfully'); // Display success message
      },
    },
  );
};
